async function getEnv<T extends boolean>(
    key: string,
    throwIfNotFound = true as T
): Promise<T extends true ? string : string | undefined> {
    const reactEnvPrefix = 'REACT_APP_';
    const parseEnv = (key: string) => {
        return key.startsWith(reactEnvPrefix) ? key : reactEnvPrefix + key;
    };

    const envValue = sessionStorage.getItem(parseEnv(key));

    if (envValue === null) {
        const envRes = await fetch('/api/env?key=' + parseEnv(key));

        if (envRes.ok) {
            const env = await envRes.text();
            sessionStorage.setItem(parseEnv(key), env);
            return env;
        } else {
            if (throwIfNotFound === true) {
                throw new Error(
                    'Environment variable value is not found. Key: ' + reactEnvPrefix + key
                );
            }
        }
    }

    return envValue as T extends true ? string : string | undefined;
}

export { getEnv };
